export const TaskHeadings1 = [
    {
        name: 'Company Name',
        value: 'companyName'
    },
    {
        name: 'Mobile',
        value: 'mobile'
    },
    {
        name: 'PAN number',
        value: 'panNo'
    },
    {
        name: 'E-Mail Address',
        value: 'email'
    },
    {
        name: 'Service City',
        value: 'city'
    },
    {
        name: 'State',
        value: 'state'
    },
    {
        name: 'Contact Person Name',
        value: 'contactPersonName'
    },
    {
        name: 'Address',
        value: 'addressLine'
    },
    {
        name: 'CIN Number',
        value: 'cinNo'
    },
    {
        name: 'Is Mega Cabs Company',
        value: 'isMegaCabsCompany'
    },
    {
        name: 'Parent Company Name',
        value: 'parentCompanyName'
    },
    {
        name: 'SAP GL Code',
        value: 'sapGlCode'
    },
    {
        name: 'Service Tax Number',
        value: 'serviceTaxNo'
    },
    {
        name: 'Created on',
        value: 'createdOn'
    },
    {
        name: 'Created by',
        value: 'createdBy'
    },
    {
        name: 'Updated on',
        value: 'updatedOn'
    },
]